import RoomLayout from "/components/shared/layouts/RoomLayout.jsx";
import RoomBox from "/components/shared/layouts/RoomBox";
import { fetchProductions } from '/api/productions';
import { flattenProductionsToShows } from '/utils';
import Shop from '/components/shared/TicketWidget/Shop';
import { find } from 'lodash';

export default function ShopView({ slug, ticketing_base_url }) {
    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
          <RoomBox style='mt-24'>
            <Shop ticketing_base_url={ticketing_base_url} slug={slug}></Shop>
        </RoomBox>
        </RoomLayout>
    );
}


export async function getStaticProps(context) {
    const url = `${process.env.API_BASE_URL}/shop/?api_key=${process.env.API_KEY}`;
    const resp = await fetch(url);
    if (resp.status != 200) {
        return {
            props: {
                error: 'cannot load shop'
            },
            revalidate: 60
        };
    }
    const data = await resp.json();
    
    return {
        props: {
            ticketing_base_url: process.env.TICKETING_BASE_URL,
            slug: data.ticketing.slug
        },
        revalidate: 60
    };
}

